export default __webpack_public_path__ + "static/media/(15).d81528b2.jpeg";